import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import NgpTextField from './NgpTextField';
import { AUTO_COMPLETE_DEFAULT, isEmailValid } from '../../utilities/FormUtilities';

const invalidEmailText = i18n._(t`Please enter a valid email address`);

function validateEmail(value, required) {
    if (!value && !required) {
        return true;
    }

    if (!isEmailValid(value)) {
        return i18n._(invalidEmailText);
    }

    return true;
}

export default function NgpEmailField(props) {
    const { inputProps, required } = props;

    const emailRules = {
        validate: (value) => validateEmail(value, required),
    };

    const theInputProps = { ...inputProps, autoComplete: AUTO_COMPLETE_DEFAULT };
    return <NgpTextField {...props} inputProps={theInputProps} fieldRules={emailRules} />;
}
